// Generated by purs version 0.15.0
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var VatA = /* #__PURE__ */ (function () {
    function VatA() {

    };
    VatA.value = new VatA();
    return VatA;
})();
var VatB = /* #__PURE__ */ (function () {
    function VatB() {

    };
    VatB.value = new VatB();
    return VatB;
})();
var VatC = /* #__PURE__ */ (function () {
    function VatC() {

    };
    VatC.value = new VatC();
    return VatC;
})();
var VatD = /* #__PURE__ */ (function () {
    function VatD() {

    };
    VatD.value = new VatD();
    return VatD;
})();
var VatE = /* #__PURE__ */ (function () {
    function VatE() {

    };
    VatE.value = new VatE();
    return VatE;
})();
var VatF = /* #__PURE__ */ (function () {
    function VatF() {

    };
    VatF.value = new VatF();
    return VatF;
})();
var VatG = /* #__PURE__ */ (function () {
    function VatG() {

    };
    VatG.value = new VatG();
    return VatG;
})();
var eqVatRate = {
    eq: function (x) {
        return function (y) {
            if (x instanceof VatA && y instanceof VatA) {
                return true;
            };
            if (x instanceof VatB && y instanceof VatB) {
                return true;
            };
            if (x instanceof VatC && y instanceof VatC) {
                return true;
            };
            if (x instanceof VatD && y instanceof VatD) {
                return true;
            };
            if (x instanceof VatE && y instanceof VatE) {
                return true;
            };
            if (x instanceof VatF && y instanceof VatF) {
                return true;
            };
            if (x instanceof VatG && y instanceof VatG) {
                return true;
            };
            return false;
        };
    }
};
var ordVatRate = {
    compare: function (x) {
        return function (y) {
            if (x instanceof VatA && y instanceof VatA) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatA) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatA) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatB && y instanceof VatB) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatB) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatB) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatC && y instanceof VatC) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatC) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatC) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatD && y instanceof VatD) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatD) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatD) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatE && y instanceof VatE) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatE) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatE) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatF && y instanceof VatF) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatF) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatF) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatG && y instanceof VatG) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Taxes (line 17, column 1 - line 17, column 28): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqVatRate;
    }
};
var genericVatRate = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return VatA.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return VatB.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return VatC.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return VatD.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return VatE.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return VatF.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return VatG.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Taxes (line 12, column 1 - line 12, column 69): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof VatA) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof VatB) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof VatC) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof VatD) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof VatE) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof VatF) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof VatG) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Taxes (line 12, column 1 - line 12, column 69): " + [ x.constructor.name ]);
    }
};
var showVatRate = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericVatRate)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatA";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatB";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatC";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatD";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatE";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatF";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "VatG";
        }
    }))))))))
};
var unscrambleDecodeVatRate = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericVatRate)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatA";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatB";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatC";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatD";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatE";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatF";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "VatG";
        }
    }))))))))(Unscramble_Enum.defaultEnumOptions)
};
var encodeVatRate = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericVatRate)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatA";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatB";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatC";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatD";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatE";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatF";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "VatG";
        }
    }))))))))
};
var decodeVatRate = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericVatRate)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatA";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatB";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatC";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatD";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatE";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatF";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "VatG";
        }
    }))))))))
};
export {
    VatA,
    VatB,
    VatC,
    VatD,
    VatE,
    VatF,
    VatG,
    genericVatRate,
    eqVatRate,
    showVatRate,
    ordVatRate,
    encodeVatRate,
    decodeVatRate,
    unscrambleDecodeVatRate
};
//# sourceMappingURL=index.js.map
